import api from './default'

export default api('/api/section', 'sections')
